import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";
import { RecruiterPriorityActionsProps } from "../types";

export const QUERY_KEY_FOR_RECRUITER_PRIORITY_ACTIONS =
  "recruiter-priority-actions";

const getData = async (props: {
  token: string;
  userInfo: any;
}): Promise<RecruiterPriorityActionsProps> => {
  const corporate_id = props?.userInfo?.current_team
    ? "?corporate_id=" + props?.userInfo?.current_team.corporate_id
    : "";

  const url = `${END_POINT.BASE_URL}/v1/recruiter-priority-actions${corporate_id}`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };

  const res = await axios.get(url, config);
  const item: RecruiterPriorityActionsProps = res.data;

  return {
    ...item,
  };
};

const RECRUITER_PRIORITY_ACTIONS_STALE_MS = 3 * 60 * 1000;

export const useGetRecruiterPriorityActions = () => {
  const { token, userInfo } = useGetUserInfo();
  const corporateId = userInfo?.current_team?.corporate_id ?? null;

  const queryData = useQuery(
    [QUERY_KEY_FOR_RECRUITER_PRIORITY_ACTIONS, corporateId],
    () => getData({ token, userInfo }),
    {
      enabled: !!token,
      staleTime: RECRUITER_PRIORITY_ACTIONS_STALE_MS,
      onError: (err: any) => {},
      onSuccess: (data) => {},
    },
  );

  return queryData;
};
